import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Read-only lookup endpoints for price lists. Used by dropdowns that pick a
 * price list to associate with a customer (ar_customers.metadata.price_list_id)
 * or as the org-level default on the Order Management module config.
 */

const PriceListOptionSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  currencyCode: z.string(),
  isActive: z.boolean(),
});

export type PriceListOption = z.infer<typeof PriceListOptionSchema>;

export const ListPriceListsResponseSchema = z.object({
  priceLists: z.array(PriceListOptionSchema),
});

export type ListPriceListsResponse = z.infer<
  typeof ListPriceListsResponseSchema
>;

export const SetCustomerPriceListInputSchema = z.object({
  customerId: z.string().uuid(),
  /** Null clears the customer's price list override. */
  priceListId: z.string().uuid().nullable(),
});

export type SetCustomerPriceListInput = z.infer<
  typeof SetCustomerPriceListInputSchema
>;

export const SetCustomerPriceListResponseSchema = z.object({
  ok: z.literal(true),
});

export const priceListsContracts = {
  list: oc.output(ListPriceListsResponseSchema).route({
    method: "GET",
  }),
  setCustomer: oc
    .input(SetCustomerPriceListInputSchema)
    .output(SetCustomerPriceListResponseSchema)
    .route({
      method: "POST",
      path: "/set-customer",
    }),
} as const;
